import React from 'react';
import ReactDOM from 'react-dom';
import {AppJournal} from './AppJournal';
import './styles/styles.scss'

ReactDOM.render(< AppJournal />,document.getElementById('root')
);

